import { Directions } from './chunks'

const directions = [
  Directions.north,
  Directions.east,
  Directions.south,
  Directions.west,
  Directions.up,
  Directions.down,
]

// collapses a normal direction into a cardinal side name
// since faces in custom blocks can be rotated, the result is sometimes an approximation!
export function normalToDirection(normal) {
  let best = directions[0]
  let bestDot = -Infinity
  for (const dir of directions) {
    const dot = normal.dot(dir.normal)
    if (dot > bestDot) {
      bestDot = dot
      best = dir
    }
  }
  return best
}
